import React, { FunctionComponent } from 'react'
import { G, Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const SideNavDocumentIcon: FunctionComponent<SideNavDocumentIconProps> = ({
  size = 32,
  fillColor,
  isFilled = false,
}) => {
  const { colors } = useTheme()
  const color = fillColor ?? colors.iconDefault
  return (
    <Svg width={size} height={size} fill='none' viewBox='0 0 32 32'>
      {isFilled ? (
        <Path
          d='M18.9561 3.87402H18.9814C18.979 3.91449 18.9766 3.95515 18.9766 3.99609V8.80566C18.9765 9.24217 18.9373 10.4245 19.4648 11.4629C19.7644 12.0525 20.2406 12.601 20.9375 12.9805C21.6112 13.3473 22.3696 13.4902 23.1504 13.4902H26.6621C26.7478 13.4902 26.8324 13.4834 26.916 13.4727L26.917 13.4805H28.6787V27.0381C28.6787 28.6948 27.3353 30.0378 25.6787 30.0381H6.32227C4.66552 30.038 3.32227 28.6949 3.32227 27.0381V4.96289C3.32227 3.30612 4.66552 1.96205 6.32227 1.96191H18.9561V3.87402ZM8.75098 22.8545C8.19877 22.8545 7.75111 23.3023 7.75098 23.8545C7.75098 24.4068 8.19869 24.8545 8.75098 24.8545H23.251C23.8029 24.8541 24.251 24.4065 24.251 23.8545C24.2508 23.3026 23.8028 22.8549 23.251 22.8545H8.75098ZM8.75098 18.3691C8.19869 18.3691 7.75098 18.8169 7.75098 19.3691C7.75111 19.9213 8.19877 20.3691 8.75098 20.3691H19.9824C20.5342 20.3686 20.9823 19.921 20.9824 19.3691C20.9824 18.8172 20.5343 18.3697 19.9824 18.3691H8.75098ZM8.75098 13.7725C8.19869 13.7725 7.75098 14.2202 7.75098 14.7725C7.75098 15.3247 8.19869 15.7725 8.75098 15.7725H16C16.5521 15.7722 17 15.3246 17 14.7725C17 14.2203 16.5521 13.7727 16 13.7725H8.75098ZM26.6621 11.4902H23.1504C21.2485 11.49 21.0102 10.2702 20.9805 9.23438L20.9766 8.80566C20.9767 7.71454 20.9766 3.99609 20.9766 3.99609L26.6621 11.4902Z'
          fill={color}
        />
      ) : (
        <G>
          <Path
            d='M20.9102 1.96289V3.96289H6.32422C5.80654 3.96289 5.38043 4.35622 5.3291 4.86035L5.32422 4.96289V27.0391C5.32432 27.5913 5.772 28.0391 6.32422 28.0391H25.6797C26.2319 28.0391 26.6796 27.5913 26.6797 27.0391V11.5059H28.6797V27.0391L28.6758 27.1934C28.598 28.7274 27.3681 29.9576 25.834 30.0352L25.6797 30.0391H6.32422L6.16992 30.0352C4.63594 29.9574 3.40593 28.7273 3.32812 27.1934L3.32422 27.0391V4.96289C3.32422 3.35779 4.58477 2.04711 6.16992 1.9668L6.32422 1.96289H20.9102Z'
            fill={color}
          />
          <Path
            d='M23.2522 22.8552C23.8044 22.8554 24.2522 23.303 24.2522 23.8552C24.2522 24.4075 23.8044 24.8551 23.2522 24.8552H8.7522C8.19991 24.8552 7.7522 24.4075 7.7522 23.8552C7.7522 23.303 8.19991 22.8552 8.7522 22.8552H23.2522Z'
            fill={color}
          />
          <Path
            d='M19.9836 18.3694C20.5357 18.3697 20.9836 18.8173 20.9836 19.3694C20.9836 19.9216 20.5357 20.3692 19.9836 20.3694H8.7522C8.19991 20.3694 7.7522 19.9217 7.7522 19.3694C7.7522 18.8171 8.19991 18.3694 8.7522 18.3694H19.9836Z'
            fill={color}
          />
          <Path
            d='M16.0012 13.7729C16.5535 13.7729 17.0012 14.2206 17.0012 14.7729C17.0012 15.3252 16.5535 15.7729 16.0012 15.7729H8.7522C8.19991 15.7729 7.7522 15.3252 7.7522 14.7729C7.7522 14.2206 8.19991 13.7729 8.7522 13.7729H16.0012Z'
            fill={color}
          />
          <Path
            d='M20.3405 2.10123C21.1545 1.82739 22.0529 2.10351 22.5719 2.78776L28.2565 10.2819C28.7155 10.887 28.7925 11.7003 28.4548 12.3805C28.117 13.0607 27.4231 13.4908 26.6637 13.4909H23.152C22.3713 13.4908 21.6129 13.3479 20.9391 12.9811C20.2422 12.6016 19.7661 12.0531 19.4665 11.4635C18.9389 10.4251 18.9781 9.24282 18.9782 8.80631V3.99674C18.9782 3.13793 19.5265 2.37508 20.3405 2.10123ZM20.9821 9.23502C21.0118 10.2709 21.2501 11.4907 23.152 11.4909H26.6637L20.9782 3.99674C20.9782 3.99674 20.9783 7.71528 20.9782 8.80631L20.9821 9.23502Z'
            fill={color}
          />
        </G>
      )}
    </Svg>
  )
}

export type SideNavDocumentIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
